export const TAB_STORAGE_KEY = "programNewsSources.tab";

export const OPS_TABS = ["sources", "articles", "events", "runs"] as const;
export type OpsTab = (typeof OPS_TABS)[number];

export function isOpsTab(value: unknown): value is OpsTab {
  return typeof value === "string" && (OPS_TABS as readonly string[]).includes(value);
}

/** The tab the operator was last on; "sources" when nothing is remembered. */
export function readStoredTab(): OpsTab {
  try {
    const stored = localStorage.getItem(TAB_STORAGE_KEY);
    return isOpsTab(stored) ? stored : "sources";
  } catch {
    return "sources";
  }
}

export function writeStoredTab(tab: OpsTab): void {
  try {
    localStorage.setItem(TAB_STORAGE_KEY, tab);
  } catch {
    // Remembering the tab is a convenience; ignore storage failures.
  }
}
